/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { useCallback } from "react";
import { useAppDispatch, useRootState } from ".";
import {
  trunkChatUrl,
  trunkChatRecent,
  trunkGetAccessToken,
  trunkChatRecentAllWorkgroup,
} from "../store/chat";

// # hooks
const useChatStore = () => {
  const dispatch = useAppDispatch();
  const chatState = useRootState((state) => state.chatStore);

  const boundChatUrl = useCallback(
    (workgroupId: string) => dispatch(trunkChatUrl(workgroupId)).then(),
    [dispatch]
  );
  const boundChatRecent = useCallback(
    (workgroupId: string) => dispatch(trunkChatRecent(workgroupId)).then(),
    [dispatch]
  );
  const boundChatRecentAllWorkgroup = useCallback(
    (size?: number) => dispatch(trunkChatRecentAllWorkgroup(size)).then(),
    [dispatch]
  );
  const boundGetAccessToken = useCallback(
    () => dispatch(trunkGetAccessToken()).then(),
    [dispatch]
  );
  return {
    chatState,
    chatUrl: boundChatUrl,
    chatRecent: boundChatRecent,
    getChatRecentAllWorkgroup: boundChatRecentAllWorkgroup,
    getAccessToken: boundGetAccessToken,
  };
};

export default useChatStore;
